<div class="modal-header">
    <h5 class="modal-title">{{title}}</h5>
    <button type="button" class="close basic-close" data-dismiss="modal" aria-label="Close" (click)="modale.close('ferme')">
      <span aria-hidden="true">&times;</span>
    </button>
</div>
<div class="modal-body">
    <span class="badge badge-info mb-2 f-14 formBadge width">INFORMATIONS</span>
    <div class="d-flex">
        <div class="flex-fill">
            <p>
                <span class="title-show">Type de maison : </span>
                <span class="title-result-show">{{model?.type?.libelle}}</span>
            </p>
            <p>
                <span class="title-show">Description : </span>
                <span class="title-result-show">{{model?.type?.description}}</span>
            </p>
        </div>
        <div class="flex-fill">
            <p>
                <span class="title-show">Crée le : </span>
                <span class="title-result-show">{{ model?.createdAt| date: "d MMMM y 'à' h:mm:ss" : '' : 'fr-FR' }}</span>
                <span class="title-show ml-5"> Par : </span>
                <span class="title-result-show">{{ model?.create }}</span>
            </p>
            <p>
                <span class="title-show">Modifié le : </span>
                <span class="title-result-show">{{ model?.updatedAt| date: "d MMMM y 'à' h:mm:ss" : '' : 'fr-FR' }}</span>
                <span class="title-show ml-5"> Par : </span>
                <span class="title-result-show">{{ model?.update }}</span>
            </p>
        </div>
    </div>

    <span class="badge badge-info my-2 f-14 formBadge width">INVENTAIRE DES ELEMENTS PRESENTS</span>
    <div *ngFor="let piece of model?.pieces" class="mb-2 rounded border bg-light">
        <div class="border-bottom p-3">
            <h6 class="mb-2">Pièce: <b>{{ piece?.libelle }}</b></h6>
        </div>
        <div class="p-3">
            <h6 class="mb-2">Liste des équipements</h6>
            <ul class="list-group list-group-flush">
                <li *ngFor="let item of piece?.options;" class="list-group-item">{{ item?.equipment?.libelle }}</li>
            </ul>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button (click)="modale.close('ferme')" type="button" class="btn btn-secondary text-left" data-dismiss="modal">
        Fermer <i class="feather icon-x-circle"></i>
    </button>
    <ng-template *ngxPermissionsOnly="'INVENTORY:MODEL:EDIT'">
        <button (click)="EDIT(model)" class="btn btn-primary">
            Modifier <i class="feather icon-edit-2"></i>
        </button>
    </ng-template>
</div>
  